<template>
                <div class="news-items mt54">
                    
                    <a href="https://mp.weixin.qq.com/s/Q7gEuoqpuSeBT2U5mZvYwQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1705389268751223.jpg" alt="深化鲁澳合作新路径，澳门代表团赴济南参访" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">01/11<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">深化鲁澳合作新路径，澳门代表团赴济南参访</div>
                                <div class="desc">1月11日，澳门工商联会、澳门质量品牌国际认证联盟和澳门山东社团总会组成的澳门代表团一行抵达济南，完成为期三天的参访活动。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/cRT-Hags2cq-XsVas5MSYg" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1705389081824168.jpg" alt="东望洋中葡数字贸易平台正式发布，开启鲁澳合作新篇章" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">01/11<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">东望洋中葡数字贸易平台正式发布，开启鲁澳合作新篇章</div>
                                <div class="desc">1月11日，东望洋中葡数字贸易平台正式发布，平台定位于跨境贸易供应链渠道入口和通道，面向各个重点产业链上的经销商、服务商、采购方等，提供韧性供应链服务，以质量品牌国际认证标准为牵引，通过打通产品全生命周期的数据，进行品牌赋能，提升产品溢价与竞争力。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/q_pqx-E2D-4ZMDRam9GPRQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1703744310645938.jpg" alt="融通湾区 珠澳琴数字人才技能培训基地揭牌" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/19<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">融通湾区 珠澳琴数字人才技能培训基地揭牌</div>
                                <div class="desc">日前，澳门融贯联合珠海市高技能人才公共实训中心、融贯新蓝(珠海横琴)科技有限公司共同建立珠澳琴数字人才技能培训基地在珠海揭牌。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/i-nj7WUS6JhDkWMHOgze9g" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1703744276792414.jpg" alt="澳门融贯参与研发的“湾区认证”首批项目公布" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/19<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">澳门融贯参与研发的“湾区认证”首批项目公布</div>
                                <div class="desc">12月19日，“湾区认证”首批项目公布仪式在深圳河套深港科技创新合作区举行。粤港澳三方共同公布15项“湾区认证”项目，“湾区认证”公共服务平台上线运行，“湾区认证”标志正式启用。市场监管总局党组成员、副局长、国家认监委主任蒲淳出席活动。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/ysbMxajDAdme5gMDS1_KdA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1703744187728034.jpg" alt="文旅赋能｜大熊猫公益巡讲在澳门" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/29<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">文旅赋能｜大熊猫公益巡讲在澳门</div>
                                <div class="desc">近日，由四川省大熊猫国家公园文化创意创新联盟、四川省平面设计师协会、成都大熊猫旅游文化产业促进会、澳门城市大学主办的“打造超级IP 赋能熊猫文创”大熊猫公益巡讲在澳门城市大学学术报告厅成功举办。活动由融贯国际总经理、澳门城市创意产业协会理事长陈祥主持。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/QFL8jHX1XZ1a9bolyORyUQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1700212839978856.jpg" alt="“星火·链网”大会在厦召开：金砖创新基地区块链公共服务平台全面运行" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/17<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">“星火·链网”大会在厦召开：金砖创新基地区块链公共服务平台全面运行</div>
                                <div class="desc">15日下午，2023“星火·链网”大会（厦门）暨数字技术赋能工业产品流通发展论坛在厦门举行。大会现场举行了金砖创新基地区块链公共服务平台——“星火·链网”厦门超级节点服务功能全面运行仪式。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/N4cfmBHXxoyHvrJFEDcNdA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1700212873577427.jpg" alt="鹭澳合作共建「金砖优品码」助力双循环" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/15<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">鹭澳合作共建「金砖优品码」助力双循环</div>
                                <div class="desc">11月15日，由厦门市工业和信息化局和中国信息通信研究院共同主办的数字技术赋能工业产品流通发展论坛暨2023“星火·链网”大会（厦门）在鹭成功举办。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/N1Txj2ezqOGfSsAqddB7Uw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1700213097729282.png" alt="澳门融贯与汶川欣禹林业公司签订战略合作协议" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/11<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">澳门融贯与汶川欣禹林业公司签订战略合作协议</div>
                                <div class="desc">11月11日上午，在“创享青春汶川· HUI聚熊猫家园”2023大熊猫国家公园自然教育嘉年华·第二届汶川汶创HUI暨羌年系列活动在集中签约环节，澳门融贯与汶川欣禹林业公司签订战略合作协议。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>